import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useTenantTheme } from '@service/tenant/TenantThemeContext';
import { Button } from 'antd';

export const CarouselArrowRight = ({
  className,
  style,
  onClick,
  ...props
}: any) => {
  const disabled = props.currentSlide === props.slideCount - 1;
  const { theme } = useTenantTheme();

  return (
    <Button
      className={className}
      style={{
        ...style,
        color: disabled ? '#BDBDBD' : '#fff',
        backgroundColor: disabled ? '#DCDCDC' : theme?.light.colors.brand[500],
        height: '48px',
        width: '48px',
        paddingTop: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '100px',
      }}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      <RightOutlined />
    </Button>
  );
};

export const CarouselArrowLeft = ({
  className,
  style,
  onClick,
  ...props
}: any) => {
  const disabled = props.currentSlide === 0;
  const { theme } = useTenantTheme();
  return (
    <Button
      className={className}
      style={{
        ...style,
        color: disabled ? '#BDBDBD' : '#fff',
        backgroundColor: disabled ? '#DCDCDC' : theme?.light.colors.brand[500],
        height: '48px',
        width: '48px',
        paddingTop: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '100px',
      }}
      disabled={disabled}
      onClick={onClick}
    >
      <LeftOutlined />
    </Button>
  );
};
